import { render, staticRenderFns } from "./WidgetFooter.vue?vue&type=template&id=1e9cb4be"
import script from "./WidgetFooter.vue?vue&type=script&lang=js"
export * from "./WidgetFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports